export const VR_SET_CURRENT_TEST_ID = 'VR_CURRENT_TEST_ID';
export const HYPERTEST_ASSOCIATED_VR_ACTIONS_REQUEST =
  'HYPERTEST_ASSOCIATED_VR_ACTIONS_REQUEST';
export const HYPERTEST_ASSOCIATED_VR_ACTIONS_RESPONSE =
  'HYPERTEST_ASSOCIATED_VR_ACTIONS_RESPONSE';
export const VR_SET_CURRENT_ASSOCITED_VR_INFO =
  'VR_SET_CURRENT_ASSOCITED_VR_INFO';
